import log from 'loglevel'
// v9対応: CPUGridLayer は削除されたため、GridLayer に変更
import { GridLayer } from '@deck.gl/aggregation-layers'
import VARIABLES from '@/assets/scss/variables.module.scss'
import ColorUtil from '@/js/util/ColorUtil.js'

// レイヤーID
const LAYER_ID = 'mesh'

// デフォルトのカラーレンジ
const COLOR_RANGE = [
  '#c8e2d5',
  '#a9d1bd',
  '#89c0a5',
  '#69af8c',
  '#499e74',
  VARIABLES.ENTITY_COLOR_GREEN,
].map((c) => [...ColorUtil.hexToRgb(c), 204])

/**
 * ヒートメッシュのレンダラー
 */
class MeshRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * デフォルトのカラーレンジ
   * @returns {Array.<Array.<Number>>}
   */
  static DEFAULT_COLOR_RANGE() {
    return COLOR_RANGE
  }

  /**
   * コンストラクタ
   * @param {Array.<Array.<Number>>} colorRange カラーレンジ
   */
  constructor({ colorRange } = {}) {
    this.colorRange = colorRange || COLOR_RANGE
  }

  /**
   * レンダラー関数を作成する
   * @param {Object|Function} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<GridLayer>}
   */
  createRenderer(data, props) {
    log.debug('MeshRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () =>
        // v9対応: GridLayer を使用
        new GridLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          cellSize: 100,
          extruded: false,
          colorRange: this.colorRange,
          getPosition: (d) => d.coordinates,
          // v9対応: 以前の CPUGridLayer と同等の挙動（CPU側での集計）を維持する場合、
          // gpuAggregation を false に設定します。
          gpuAggregation: false,
          parameters: {
            blend: true,
            depthRange: [0, 0.89],
          },
          ...props,
        }),
    }
  }
}

MeshRenderer.LAYER_ID = LAYER_ID

export default MeshRenderer
